const PREFIXO_DOMINIO_LAQUS = 'laqus.';

const CONTAS_LAQUS_COM_LOGIN_POR_SENHA = [
  // Produção
  'efex.imfprod@laqus.com.br',
  'depositaria@laqus.com.br',
  'frontier+0a03a53c-8d57-476c-869d-a0741924873f+54aecc86-d572-4d5b-b86e-da760f2c48a6@laqus.com.br',
  'acompanhamento@laqus.com.br',
  'usr.liquidacao@laqus.com.br',
  'usr.integraescrituracao@laqus.com.br',
  'pentest.rtm@laqus.com.br',
  'frontier+qflash@laqus.com.br',
  'operacoes.imf@laqus.com.br',
  'usr.apescrituracao@laqus.com.br',
  'usr.onbmv@laqus.com.br',
  'test.emissor@laqus.com.br',
  // Homologação
  'frontier+59fd78ae-de1b-457d-801d-437934ef48f6+3291daae-d6da-4a01-b034-b8728dd5b143@laqus.com.br',
  'test.gerentecontas@laqus.com.br',
  'test.master@laqus.com.br',
  'frontier+fa7694ed-b0cb-4055-b1ee-deb1a7da5395+fdf875ae-72cc-496a-9e8a-739d17b684fe@laqus.com.br',
  'frontier+fa7694ed-b0cb-4055-b1ee-deb1a7da5395+bade58c4-e657-4d94-b1b1-ebfd739d8be5@laqus.com.br',
  'test.custodiante2@laqus.com.br',
  'frontier+44e2fc6a-6126-4f8a-8b6a-ead76fbaaa96+e5240e93-f45d-4dfc-8915-8af70926400e@laqus.com.br',
  'frontier+54221f65-a1f6-41a7-90fb-b2597cd510e5+096bc154-4e39-4414-850b-f8d7a35880fe@laqus.com.br',
  'frontier+c6f3fc2b-8878-4e1b-9c08-72b64388dc3d+7f8e09ce-2f19-4319-86b0-c58572e2c4e7@laqus.com.br',
  'frontier+2514c5d2-3ace-4e7e-b922-c32307cb452a+c07be80c-f662-43a0-97ca-bd573a78cb5e@laqus.com.br',
  'frontier+fa7694ed-b0cb-4055-b1ee-deb1a7da5395+cbc14658-8690-4ea4-9afa-d815a7d10a34@laqus.com.br',
  'frontier+7d4794b3-9a45-4a77-87ad-2e05a7c99fab+bcf8018a-e55b-4fe7-974d-d25a5c6b699c@laqus.com.br',
  'frontier+ae9ae531-281b-4b11-88df-38976049a0ef+e09a9ac5-2bde-41b3-9347-75095393b993@laqus.com.br',
  'frontier+a5656b69-fdfe-4706-b66b-8ac3551e840b+502b418b-731c-49fd-85d7-6b876c7a5b55@laqus.com.br',
  'frontier+f04d2a6d-adc0-4bbd-9cc8-cb4984784169+54907a30-fc50-460d-b3f4-b059691ec2ef@laqus.com.br',
  'frontier+03c8c092-d032-4dc3-8db6-d90dfd061bca+24047623-e80e-4f44-a952-cf637e5e3840@laqus.com.br',
  'frontier+94965dff-59a8-4534-9a34-9dac73360333+fa3b843f-d02a-42a2-adc5-941b8bc0eeeb@laqus.com.br',
  'frontier+fa7694ed-b0cb-4055-b1ee-deb1a7da5395+686601a8-4fd5-4aec-9c94-02138762f20e@laqus.com.br',
  'frontier+fa7694ed-b0cb-4055-b1ee-deb1a7da5395+aebc34ae-dd9c-4cbe-a4ea-65645b59968f@laqus.com.br',
  'frontier+f04d2a6d-adc0-4bbd-9cc8-cb4984784169+6528a2a6-9d34-41ac-917b-58eda566a453@laqus.com.br',
  'frontier+e8f45d4a-80f8-4604-9a04-b3a7451b539b+678bb48c-6dba-4a12-a8eb-80dc98be8be8@laqus.com.br',
  'escrita.gestao.acessos@laqus.com.br',
  'frontier+fa7694ed-b0cb-4055-b1ee-deb1a7da5395+5e3ed5d9-e31c-4c65-b5f9-ae9f3937d12d@laqus.com.br',
  'frontier+27cc6d88-1a3d-4f16-bafe-94df27af1bb4+3db0cb27-3f5b-43f3-b857-2b3b5595e780@laqus.com.br',
  'frontier+9ec88b08-b8fc-49ec-aaad-b6cd2ee0f65f+18dbb4b4-492b-4dd4-9405-e54a79f8f2a9@laqus.com.br',
  'frontier+a5d0153d-ed86-4baa-8d1c-b74abfd01b1a+8ada4504-db3f-44b9-9415-d75b6975d2fd@laqus.com.br',
  'frontier+6dec592b-6adc-41a1-b1ef-7c6292dfb20b+a06f4b0e-a279-4aef-b74a-2681009031f0@laqus.com.br',
  'frontier+1a9e093b-1cb1-42a3-9d72-afc33c343012+9bc25a2c-7e9d-47a8-8a5b-a34249c88146@laqus.com.br',
  'frontier+f04d2a6d-adc0-4bbd-9cc8-cb4984784169+474c5ffd-0c15-4833-bfb2-2dcfc3c9973f@laqus.com.br',
  'frontier+fa7694ed-b0cb-4055-b1ee-deb1a7da5395+40ecfb3f-d664-4fe8-be7f-e72d179d7252@laqus.com.br',
  'frontier+9ec88b08-b8fc-49ec-aaad-b6cd2ee0f65f+b8c69ee7-e66d-434d-8427-58543549ff0e@laqus.com.br',
  'frontier+fe61ac09-a21f-48a7-9ec4-919527f34a0a+c384c03a-a64b-4806-9358-690f499e53f9@laqus.com.br',
  'frontier+8a053d17-7912-459e-9756-8cdbe6b99c69+6023550c-5d50-4483-bcf4-d25683f5c155@laqus.com.br',
  'frontier+95cfb437-0ab8-447b-a8d5-cf2f85069abc+54430c0a-ec1c-41b7-87c0-92a08d056501@laqus.com.br',
  'frontier+a48fe624-ce1b-425f-8922-908896aeb38b+9d510b52-93ea-4e2b-87b8-023577ecc7e7@laqus.com.br',
  'frontier+f04d2a6d-adc0-4bbd-9cc8-cb4984784169+827dfae9-1487-49a9-9094-2fcdc2c98dbb@laqus.com.br',
  'frontier+87fd89e0-1951-4701-83fe-fa2100abfaed+4e1e4510-670a-4431-a644-3b2b96dfeeb5@laqus.com.br',
  'frontier+3d6280f8-57d2-421b-be02-bee92fc1db86+91fb4c53-547b-4e7f-a5d0-a572d2259d14@laqus.com.br',
  'frontier+649528e9-abcd-4b1a-b262-84ca5106808f+747bbdf3-4888-44eb-a252-8eff25bad397@laqus.com.br',
  'frontier+ee495881-eaf2-4a38-bde1-6da67f8febbb+5dd5b9db-f9e3-4ac5-8e9d-83b02f34d5c5@laqus.com.br',
  'frontier+95f2f3aa-34c8-499a-abd5-34e5173dfcb5+3f090cf1-97e4-426b-b994-e7663b0a076e@laqus.com.br',
  'frontier+3d6280f8-57d2-421b-be02-bee92fc1db86+9ea89953-5ca9-4eb9-9f78-f9b9e117b5af@laqus.com.br',
  'frontier+deb195e9-d8d5-49a9-bac6-90b0faadcf51+7159553d-0d2d-4624-91b4-45fcdf28b9ba@laqus.com.br',
  'frontier+475a707b-98bb-47d7-8fb4-ed1abbc3acfb+7074a60c-1c49-4b33-ba19-7d969b0da704@laqus.com.br',
  'frontier+f04d2a6d-adc0-4bbd-9cc8-cb4984784169+81c84f77-fe5c-4775-a09e-bfacffe383ea@laqus.com.br',
  'frontier+08701704-56db-4463-9b9c-f262eb0516e8+13de972e-21a1-45d0-9a42-55cff3086bc7@laqus.com.br',
  'frontier+f4bf8e6c-f5ca-4a6b-b6b5-bb592f67e183+84f9dea0-73d0-43d4-841e-a6f541d6ad63@laqus.com.br',
  'frontier+86f98f44-2a36-4285-8c9b-baa27cafd4dc+0f69d244-f680-4485-a134-9b2c65bf2c27@laqus.com.br',
  'frontier+0d884748-ebaf-4fcb-a2eb-1052208d18ba+e7d4d66c-2cde-4837-9cd2-12888a14e901@laqus.com.br',
  'frontier+3d6280f8-57d2-421b-be02-bee92fc1db86+a96d4aec-9ba1-42b2-a098-6db208eecf4a@laqus.com.br',
  'frontier+66ea0976-68ee-42dd-9e75-2eee1fe40913+f6da4ada-f9bf-48c7-ae27-490ff0e7f742@laqus.com.br',
  'frontier+e046ad95-2a80-4743-b104-23507701476f+2c93db54-6ad2-471e-a14c-164851d990cf@laqus.com.br',
  'frontier+f04d2a6d-adc0-4bbd-9cc8-cb4984784169+78a02dfb-6258-455c-bfdf-1213066cfbb2@laqus.com.br',
  'frontier+fa7694ed-b0cb-4055-b1ee-deb1a7da5395+da69fb80-c344-4446-a182-65287a93012d@laqus.com.br',
  'frontier+dc64c7f3-a578-477c-9c2c-bb267d3bccaf+bba863ee-a14a-402a-8db6-58645ea2b5b4@laqus.com.br',
  'frontier+da361727-a29f-4714-b370-9cef6bb36783+afd13ae2-8e71-4412-9c77-93ebb9b59974@laqus.com.br',
  'teste.admfiduc@laqus.com.br',
  'leitura.gestao.acessos@laqus.com.br',
  'test.escriturador@laqus.com.br',
  'test.operacoes.leitura@laqus.com.br',
  'master.gestao.acessos@laqus.com.br',
  'test.controlesinternos@laqus.com.br',
  'test.cadastro.operacoes@laqus.com.br',
  'test.custodiante@laqus.com.br',
  'test.operacoes@laqus.com.br',
].map((conta) => conta.toLowerCase());

function normalizarEmail(email: string): string {
  return String(email ?? '')
    .trim()
    .toLowerCase();
}

export function ehContaLaqus(email: string): boolean {
  const emailNormalizado = normalizarEmail(email);
  const posicaoArroba = emailNormalizado.lastIndexOf('@');

  if (posicaoArroba < 0) return false;

  return emailNormalizado.slice(posicaoArroba + 1).startsWith(PREFIXO_DOMINIO_LAQUS);
}


export function deveUsarSsoLaqus(email: string): boolean {
  const emailNormalizado = normalizarEmail(email);

  if (!ehContaLaqus(emailNormalizado)) return false;

  return !CONTAS_LAQUS_COM_LOGIN_POR_SENHA.includes(emailNormalizado);
}
